import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_react-dom@18_ixrbvmtvnipsi5ntc6vhm3s7wm/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/aida/AidaProvider/AidaProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/providers/Axios.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/providers/FlowbiteThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/providers/Hotjar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/providers/Mixpanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/providers/SentryUser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsStoreProvider"] */ "/vercel/path0/src/components/providers/stores/BreadcrumbsStoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastStoreProvider"] */ "/vercel/path0/src/components/providers/stores/ToastStoreProvider.tsx");
